<!-- TEMPLATE -->
<template>
    <div :class='quotesListClass'>
      <div class='row'>
        <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
          <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>Offertes</span>
            </span>

            <dean-section-title-item
              v-if="canCreateQuote()"
              :icon='plusIcon'
              :content="true"
              @click.native="addQuote()"
            >
              Nieuw
            </dean-section-title-item>
          </dean-section-title>

          <dean-table
            :data='quotesData'
            :columns='columns'
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick"
          >
          </dean-table>

          <dean-pagination
            :current-page='quotesMetaData.pageNumber'
            :total-items='quotesMetaData.totalResults'
            :items-per-page='quotesMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='quotesMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
          >
          </dean-pagination>
        </div>
      </div>
    </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';
  import sideMenuCustomerMixin from '@/mixins/sideMenuCustomerMixin';
  import { getDutchDateFormat } from '@/mixins/dateWrapper';
  import { formatPrice } from '@/mixins/formatPrice';

  import {
    // SVG
    invoicesIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
  } from '@deanone/dean-components';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuCustomerMixin) {

    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public data: object[] = [];

    // COMPUTED
    get quotesListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get quotesMetaData() {
      return this.pageMeta;
    }

    get quotesData() {
      return this.data;
    }

    get columns(): any {
      const columns: any = {
        number: {
          content: 'Offerte-id',
          align: 'left',
          sort: true,
          dql: 'number',
        },
        customerName: {
          content: 'Klantnaam',
          align: 'left',
          sort: true,
          dql: 'customerName',
        },
      };
      if (this.$store.getters.getUser.privileges.includes('view-partner')) {
        columns.partnerName = {
          content: 'Partnernaam',
          align: 'left',
          sort: true,
          dql: 'partnerName',
        };
      }
      return {...columns, ...{

          pchsnr: {
            content: 'Pc/hsnr',
            align: 'left',
            sort: true,
            dql: 'pchsnr',
          },
          city: {
            content: 'Plaats',
            align: 'left',
            sort: true,
            dql: 'city',
          },
          quoteDate: {
            content: 'Date',
            align: 'left',
            sort: true,
            dql: 'quoteDate',
          },
          recurringPrice: {
            content: 'Maandelijks',
            align: 'left',
            sort: true,
            dql: 'recurringPrice',
          },
          status: {
            content: 'Status',
            align: 'left',
            sort: true,
            dql: 'status',
          },
        },
      };
    }

    public tableName(): string {
      return 'customer-quotes';
    }

    public cellClick(target: { cell: object, row: any, column: string }) {
      if (
          target.row.status === 'Gewonnen'
          && this.$store.getters.getUser.privileges.includes('view-order')
      ) {
        this.$router.push({
          name: 'orders.orderlines',
          params: {
            transactionId: target.row.transactionId,
          },
        });
      } else if (this.$store.getters.getUser.privileges.includes('view-quote')) {
        this.$router.push({
          name: 'quotes.edit',
          params: {
            id: target.row.id,
          },
        });
      } else {
        return;
      }
    }

    public createQuote(agreementId: string) {
      this.$store.dispatch('setLoadOverlay', true);
      axios.post('/-/trade/api/quote.create', {
        customerId: this.$route.params.pid,
        paid: agreementId,
      }).then(
          (response) => {
            this.$toast({
              text: 'Offerte toegevoegd.',
              theme: 'success',
              icon: plusIcon,
            });

            this.$router.push({
              name: 'quotes.edit',
              params: {
                id: response.data,
              },
            });
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
      ).finally(
          () => {
            this.$store.dispatch('setLoadOverlay', false);
          },
      );
    }

    public addQuote() {
      if (this.$store.getters.getUser.privileges.includes('view-partner')) {
        this.getPartners();
      } else {
        this.getAgreements(this.$store.getters.getUser.organizationId);
      }
    }

    public getPartners() {
      this.$store.dispatch('setLoadOverlay', true);
      axios.post('/-/trade/api/customer.partner.list', {
        id: this.$route.params.pid,
      }).then(
          (response) => {
            const partners = response.data;
            switch (true) {
              case (partners.length === 0):
                this.$toast({
                  title: 'Fout',
                  text: 'Er kunnen momenteel geen partners voor deze klant gevonden worden, er kan helaas geen offerte aangemaakt worden.',
                  theme: 'danger',
                });
                this.$store.dispatch('setLoadOverlay', false);
                break;
              case (partners.length === 1):
                this.getAgreements(partners[0].value);
                break;
              case (partners.length > 1):
                this.$store.dispatch('setLoadOverlay', false);
                this.openDialog(
                    partners,
                    'partner',
                    (partnerId: string) => this.getAgreements(partnerId),
                );
                break;
            }
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
            this.$store.dispatch('setLoadOverlay', false);
          },
      );
    }

    public getAgreements(partnerId: string) {
      this.$store.dispatch('setLoadOverlay', true);
      axios.post('/-/trade/api/customer.partner.agreements.list', {
        id: partnerId,
        activeOnly: true,
      }).then(
          (response) => {
            const agreements = response.data.data;
            switch (true) {
              case (agreements.length === 0):
                this.$toast({
                  title: 'Fout',
                  text: 'De partner van deze klant heeft geen overeenkomsten, er kan geen offerte aangemaakt worden.',
                  theme: 'danger',
                });
                this.$store.dispatch('setLoadOverlay', false);
                break;
              case (agreements.length === 1):
                this.createQuote(agreements[0].id);
                break;
              case (agreements.length > 1):
                this.$store.dispatch('setLoadOverlay', false);
                this.openDialog(
                    agreements.map((agreement: any) => ({
                        value: agreement.id,
                        label: agreement.description + ' (' + agreement.typeName + ')',
                    })),
                    'overeenkomst',
                    (agreementId: string) => this.createQuote(agreementId),
                );
                break;
            }
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
            this.$store.dispatch('setLoadOverlay', false);
          },
      );
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post('/-/trade/api/customer.quotes.list', {
        id: this.$route.params.pid,
        meta: {
          startIndex: ((data.pageNumber - 1) * data.itemsPerPage), // TODO move calc somewhere else ?
          numberOfItems: data.itemsPerPage,
        },
        sort: data.sort,
      }).then(
        (response) => {

          this.data = response.data.data.map((quote: any) => {
            return {
              id: quote.id,
              personId: this.$route.params.pid,
              number: quote.number,
              customerName: quote.customer.name,
              partnerName: quote.partner.name,
              pchsnr: quote.address ? (quote.address.postalCode +
                  ' / ' +
                  quote.address.houseNumber + (
                      quote.address.houseNumberExtension ?
                          '-' + quote.address.houseNumberExtension :
                          ''
                  )
              ) : '-',
              city: quote.address ? quote.address.city : '-',
              quoteDate: getDutchDateFormat(quote.created),
              recurringPrice: formatPrice(quote.recurringPrice),
              status: quote.status,
              transactionId: quote.transactionId,
            };
          });

          this.updateMeta(response.data.meta);
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(
        () => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public canCreateQuote(): boolean {
      if (this.$store.getters.getUser.privileges.includes('create-quote')) {
        return true;
      }

      return false;
    }

    public created() {
      this.setDefaultSort('number');
      this.loadList(this.pageMeta);
      this.buildSideMenuCustomer(this.$route.params.pid);
    }

    public openDialog(options: any, title: string, callback: (arg: any) => void) {
      deanDialogBus.$emit('open', 'SelectOptionDialog', {
        options,
        title,
        callback,
      });
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>